import {
  Stringified,
  ionicStorageClass,
} from "@/persistentStorage/ionicStorageClass";
//import { downloadWriteFile } from "@/helpers/imagesReadWrite";
import { getDir, createFolder } from "@/helpers/imagesReadWrite";
import { readFile, writeFile, blobToBase64 } from "@/helpers/filesReadWrite";

import { useIcons } from "@/stores/pageLayoutsStore";
import { iconProgress } from "@/globals/helpers/iconProgress";
import { iconsFilesDB } from "@/persistentStorage/iconsStorageFiles";

import { urls } from "@/stores/urls";
const url = urls();

//interface iconslist { name:string, list:[] }
export interface IIcons {
  screen_id: string;
  icons: object;
  iconsdark: object;
  last_update: string;
}

export interface IconDownloadSummary {
  requested: number;
  downloaded: number;
  failed: number;
  ms: number;
}

type IconJob = {
  screen: string;
  type: "icons" | "iconsdark";
  key: string;
  path: string;
};

async function createIconsDIR() {
  const dir = await getDir("");
  if (!dir.find((x) => x.name === "milage_icons")) {
    await createFolder("milage_icons");
  }
}

//-----------------------------------
//Class definition
class IconsLocalFiles extends ionicStorageClass {
  constructor(name: string, storeName: string) {
    createIconsDIR();
    super(name, storeName);
  }

  //------------------------

  async getIconInfo(key: string): Promise<{
    page: string;
    size: number;
    type: string;
    uri: { uri: string };
  } | null> {
    const info = await this.getDatabaseItem(key);
    return info as {
      page: string;
      size: number;
      type: string;
      uri: { uri: string };
    } | null;
  }

  //----------
  //   async readWriteIconsFromPageList(lst: string[]) {
  //     const iconStore = useIcons();
  //     lst.forEach((element) => {
  //       const iconsPage = iconStore.getPage(element);
  //       const icons = Object.entries(iconsPage.icons);
  //       const iconsdark = Object.entries(iconsPage.iconsdark);
  //       //console.log("ICONS", icons)
  //       const aa = [
  //         { name: "icons", list: icons },
  //         { name: "iconsdark", list: iconsdark },
  //       ];
  //       aa.forEach((item) => {
  //         const type = item.name;
  //         if (item.list.length > 0) {
  //           item.list.forEach(async ([icon_key, icon_item]) => {
  //             const filename = `${element}_${type}_${icon_key}`;
  //             const url0 = `${url.getStatic}${icon_item}`;
  //             const response = await fetch(url0);
  //             const blob = await response.blob();
  //             if (blob.type == "image/svg+xml") {
  //               new Blob([blob], { type: "image/png" });
  //             }
  //             const data64 = await blobToBase64(blob);
  //             const uri = await writeFile("milage_icons/" + filename, data64);
  //             const id = `${element}_${type}_${icon_key}`;
  //             const stringified: Stringified<any> = JSON.stringify({
  //               page: element,
  //               type: blob.type,
  //               size: blob.size,
  //               uri: uri,
  //             }) as Stringified<any>;
  //             this.setDatabaseItem(id, stringified);
  //             iconsFilesDB.saveFile(id, data64 as string);
  //           });
  //         }
  //       });
  //     });
  //   }
  //--------
  /** Achata os ecrãs pedidos numa lista plana de downloads. */
  private collectJobs(screens: string[]): IconJob[] {
    const iconStore = useIcons();
    const jobs: IconJob[] = [];

    for (const screen of screens) {
      const page = iconStore.getPage(screen);
      for (const type of ["icons", "iconsdark"] as const) {
        const table = page?.[type];
        // getPage devolve { icons: "", iconsdark: "" } para ecrãs desconhecidos
        if (!table || typeof table !== "object") continue;

        for (const [key, path] of Object.entries(
          table as Record<string, string>,
        )) {
          if (path) jobs.push({ screen, type, key, path: String(path) });
        }
      }
    }
    return jobs;
  }

  /** Descarrega e grava um ícone. Nunca lança. */
  private async downloadOne(
    job: IconJob,
  ): Promise<{ ok: boolean; bytes: number }> {
    const id = `${job.screen}_${job.type}_${job.key}`;

    try {
      const response = await fetch(`${url.getStatic}${job.path}`);
      if (!response.ok) return { ok: false, bytes: 0 };

      const blob = await response.blob();
      const data64 = (await blobToBase64(blob)) as string;

      const uri = await writeFile("milage_icons/" + id, data64);
      const meta = JSON.stringify({
        page: job.screen,
        type: blob.type,
        size: blob.size,
        uri,
      }) as Stringified<any>;

      await this.setDatabaseItem(id, meta);
      await iconsFilesDB.saveFile(id, data64);
      return { ok: true, bytes: blob.size };
    } catch {
      return { ok: false, bytes: 0 };
    }
  }

  /** Resolve apenas quando todos os downloads terminarem. */
  async readWriteIconsFromPageList(
    lst: string[],
    concurrency = 6,
  ): Promise<IconDownloadSummary> {
    const started = Date.now();
    const jobs = this.collectJobs(lst);
    iconProgress.start(jobs.length);

    let downloaded = 0;
    let failed = 0;
    let next = 0;
    try {
      await Promise.all(
        Array.from({ length: Math.min(concurrency, jobs.length) }, async () => {
          while (next < jobs.length) {
            const r = await this.downloadOne(jobs[next++]);
            r.ok ? downloaded++ : failed++;
            iconProgress.tick(r.bytes, r.ok);
          }
        }),
      );
    } finally {
      iconProgress.finish();
    }

    return {
      requested: jobs.length,
      downloaded,
      failed,
      ms: Date.now() - started,
    };
  }

  /** Purga legada (E9.4). Remover na versão seguinte. */
  async clearAll(): Promise<void> {
    await this.ready;
    await this.clearDatabase();
  }

  //----------
  /*
    async writeIconsFiles(iconsSrc:IIcons){
        const icons = Object.entries(iconsSrc.icons);
        const iconsdark = Object.entries(iconsSrc.iconsdark); 
        console.log("ICONS", icons)
        const aa = [{name:'icons', list:icons}, {name:'iconsdark', list: iconsdark}]
        aa.forEach( ( item ) => {
            const type = item.name;
            if (item.list.length > 0){
                item.list.forEach( async ([icon_key, icon_item]) => {
                        const filename = `${iconsSrc.screen_id}_${type}_${icon_key}`;
                        const url0 = `${url.getStatic}${icon_item}`;
                        //console.log("ICONS LOAD",filename, url0)
                        const response = await fetch(url0)//.then((resp) => {resp});//.catch((err)=>console.log("fetch error",page.screen_id));
                        //console.log("FETCH", response);
                        const blob = await response.blob();
                        //console.log("BLOB", blob);
                        const uri = await downloadWriteFile("milage_icons/"+filename, blob);
                        //console.log("URI", uri);
                        const id = `${iconsSrc.screen_id}_${type}_${icon_key}`;
                        this.setDatabaseItem(id, {page:iconsSrc.screen_id, type:blob.type, size:blob.size});
                    })    
            }
        })
    } */
  //----------
}

export const iconsLocalFiles = new IconsLocalFiles("icons", "icons-db");
